<div>
    <div style="display: flex;
    justify-content: center;" class="video-wrapper">
    <video class="video" (ended)="vidEnded()" #bVideo>
      <source src="../../../assets/videos/homeVideo.mp4" type="video/mp4" />
    </video>
    @if (showReplay) {
      <div class="{{(utils.isDarkMode() ? 'replayButton video dark-background' : 'replayButton video')}}" #replayButton (click)="toggleVideo()"></div>
    }
    @if (showPlay) {
      <div class="{{(utils.isDarkMode() ? 'playButton video dark-background' : 'playButton video light-background')}}" #replayButton (click)="toggleVideo()"></div>
    }
  </div>
</div>
<div class="d-flex justify-content-center">
  <div i18n="@@trySalesScript" class="mat-headline-6">Try sales script completely free</div>
</div>
<div class="d-flex justify-content-center">
  <button i18n="@@signUp" data-testid="openSignup_button" class="signup-button" mat-raised-button color="accent" (click)="openSignup()">Sign Up</button>
</div>
<div class="d-flex justify-content-center our-partner">
  <h1 i18n="@@ourCustomers" class="mat-headline-5">Our Customers</h1>
</div>
<rm-image-slider
  [animationSpeed]="5"
  [imagePopup]="false"
  class="logo-slider"
  [infinite]="true"
  [autoSlide]="2"
  [images]="logosList"
  #nav
  [imageSize]="{width: 200, height: 'auto', space: 5}"
></rm-image-slider>
